import { Amplify, ResourcesConfig } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { CookieStorage } from 'aws-amplify/utils';
import config from './config';

const AuthConfig: ResourcesConfig['Auth'] = {
  Cognito: {
    userPoolEndpoint: config.Cognito.IdpEndpoint,
    identityPoolId: config.Cognito.IdentityPoolId,
    allowGuestAccess: true,
    userPoolClientId: config.Cognito.ClientId,
    userPoolId: config.Cognito.UserPoolId,
    signUpVerificationMethod: 'code',
  },
};

const awsConfig: ResourcesConfig = {
  API: {
    GraphQL: {
      endpoint: config.AppSyncUrl,
      region: 'eu-west-3',
      defaultAuthMode: 'userPool',
    },
  },
  Auth: AuthConfig,
};

Amplify.configure(awsConfig);
cognitoUserPoolsTokenProvider.setKeyValueStorage(new CookieStorage({
  domain: config.Auth.Cookies.CookieDomain,
  path: '/',
  expires: 365,
  sameSite: 'lax',
  secure: true,
}));

export default awsConfig;
